// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ntftplEntity from './entities/ntftpl.json';
import ntftplMenu from '../pages/ntftpl/menu.json';
import ntftplFullForm from '../pages/ntftpl/forms/full.json';
import ntftplContextForm from '../pages/ntftpl/forms/context.json';
import ntftplMiniForm from '../pages/ntftpl/forms/mini.json';
import ntftplLookupForm from '../pages/ntftpl/forms/lookup.json';
import ntftplTableView from '../pages/ntftpl/views/table.json';
import ntftplStagesView from '../pages/ntftpl/views/stages.json';
import ntftplCardsView from '../pages/ntftpl/views/cards.json';
import ntftplInlineView from '../pages/ntftpl/views/inline.json';
import ntftplBacklogView from '../pages/ntftpl/views/backlog.json';
import ntftplSplitView from '../pages/ntftpl/views/split.json';
import ntftplCalendarView from '../pages/ntftpl/views/calendar.json';
import ntftplDashboardView from '../pages/ntftpl/views/dashboard.json';

/** Тип запису «Шаблон сповіщення» зі сторінками пакета: меню, форми та подання з pages/ntftpl/. */
export const ntftplDefinition: IRecordTypeDefinition = {
  ...ntftplEntity,
  views: assembleViewSet({
      table: ntftplTableView,
      stages: ntftplStagesView,
      cards: ntftplCardsView,
      inline: ntftplInlineView,
      backlog: ntftplBacklogView,
      split: ntftplSplitView,
      calendar: ntftplCalendarView,
      dashboard: ntftplDashboardView,
  }),
  form: ntftplFullForm,
  forms: { full: ntftplFullForm, context: ntftplContextForm, mini: ntftplMiniForm, lookup: ntftplLookupForm },
  menu: ntftplMenu,
} as IRecordTypeDefinition;
